import {ResetView} from "../hooks/resetview";

export function useResetViewMapControl(initialLatLng, initialZoom, otherOptions = {}) {
    const addResetViewMapControl = map => {
        new ResetView({
            latlng: initialLatLng,
            zoom: initialZoom,
            title: "Reset zoom",
            ...otherOptions,
        }).addTo(map);
    };

    return {addResetViewMapControl};
}
